<style scoped>

    .content {

        height: 100vh;
        width: 1640px;
        /*background-color: #71a4d1;*/
        /*display: block;*/
    }

    #realtime-project-trend {
        width: 65%;
        height: 100vh;
        float: left;
        /*margin-left: 400px;*/
        /*margin-top: 30px;*/
        /*padding-top: 30px;*/
        /*background-color: #f7f7f7;*/
    }

    #realtime-tend-data {
        width: 35%;
        height: 90%;
        float: right;
        /*margin-right: 30px;*/
        /*margin-top: 30px;*/
        /*padding-top: 30px;*/
        /*background-color: #f7f7f7;*/
        opacity: 0.8;
        margin-top: 100px;
        overflow-x: hidden;
        background-color: rgba(148, 144, 144, 0.1);
    }

    el-table td {
        background-color: #75517d;
    }

    /*.el th, .el tr {*/
    /*    background-color: rgba(148, 144, 144, 0.3);*/
    /*}*/
</style>
<template>
    <div class="content">
        <div class="left">
            <div id="realtime-project-trend"></div>
        </div>
        <!--        <div>-->
        <div id="realtime-tend-data">
            <el-select style="width:120px; padding-right: 10px;" v-model="eiatypevalue" clearable
                       @change="eia_type_change" placeholder="请选择">
                <el-option
                        v-for="item in eiatypeoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
            <el-table
                    class="el"
                    :data="tableData"
                    height="700"
                    border
                    style="width: 100%;">
                <el-table-column
                        prop="time"
                        label="时间"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="project_name"
                        label="项目名称"
                        width="400">
                </el-table-column>

            </el-table>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="page_size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>

    import echarts from 'echarts';
    import {
        CreditPorjectRealtimeData,
        CreditPorjectRealtimeTrend
    } from "../../../../network/projectAnalysis";

    export default {
        name: 'DayTrendBarv2',
        data() {
            return {
                eiatypevalue: "全部类型",
                eiatypeoptions: [
                    {value: "全部类型", label: "全部类型"},
                    {value: "报告书", label: "报告书"},
                    {value: "报告表", label: "报告表"},

                ],
                mychart: '',
                tableData: [],
                option: {
                    title: {
                        text: '实时趋势',
                        // left: 200,
                        textStyle: {
                            color: "#f7f7b6",
                            fontSize: 16,
                        },
                        // right: 140,
                        top: 100,
                        left: "middle",
                        z: 0,
                        // right: "auto",
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "shadow",
                            textStyle: {
                                color: "#1b2947"
                            }

                        },

                    },
                    grid: {
                        borderWidth: 0,
                        top: 150,
                        height: 650,
                        // bottom: 200,
                        // left:10,
                        // textStyle: {
                        //     color: "#fff"
                        // }

                    },
                    legend: {
                        // x: '46%',
                        top: '130',

                        textStyle: {
                            color: '#f7f7b8',
                            fontSize: 14,
                        },
                        data: ['总量', '报告表', '报告书'],
                    },

                    toolbox: {
                        feature: {
                            magicType: {
                                type: ['line', 'stack', 'bar']
                            },
                            saveAsImage: {
                                pixelRatio: 2,
                                backgroundColor: "#1D2A48"
                            },


                        },
                        iconStyle: {
                            borderColor: '#f7f7b6'
                        },
                        top: 130,
                        right: 50,
                    },
                    calculable: true,
                    xAxis: [{
                        type: "category",
                        axisLabel: {
                            // interval: 0,
                            textStyle: {
                                color: '#f7f7b6',
                                align: 'left',
                                fontSize: 16,

                            },
                        },
                        axisLine: {
                            fontSize: 16,
                            // lineStyle: {
                            //     color: "rgba(204,187,225,0.5)",
                            // }
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: true
                        },
                        // data: []
                    }],

                    yAxis: [{
                        type: "value",
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            fontSize: 16,
                            color: '#f7f7b6',
                        },
                        // axisLine: {
                        //     lineStyle: {
                        //         color: "rgba(204,187,225,0.5)",
                        //     }
                        // },

                    }],
                    dataZoom: [{
                        show: true,
                        height: 30,
                        xAxisIndex: [0],
                        bottom: 30,

                        "start": 0,
                        "end": 100,
                        handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
                        // handleSize: '110%',
                        handleStyle: {
                            color: "#f7f7b6",
                        },
                        // textStyle: {
                        //     color: "rgba(204,187,225,0.5)",
                        // },
                        // fillerColor: "rgba(67,55,160,0.4)",
                        // borderColor: "rgba(204,187,225,0.5)",

                    }, {
                        type: "inside",
                        show: true,
                        height: 15,
                        start: 1,
                        end: 35
                    }],

                    series: [{
                        name: "报告表",
                        type: "line",
                        // stack: "总量",
                        symbolSize: 10,
                        symbol: 'circle',
                        itemStyle: {
                            color: "#e61464",
                        },
                        label: {
                            normal: {
                                show: true,
                                fontSize: 16,
                                color: "#f7f7b6",
                                textBorderColor: '#333',
                                textBorderWidth: 2
                            }
                        },
                        markLine: {
                            lineStyle: {
                                width: 2,
                            },
                            label: {
                                fontSize: 20,
                                color: "#e61464"
                            },
                            data: [
                                {type: 'average', name: '平均值'},
                                [{
                                    symbol: 'none',
                                    x: '90%',
                                    yAxis: 'max'
                                }, {
                                    symbol: 'circle',
                                    label: {
                                        position: 'start',
                                        formatter: '最大值',
                                        fontSize: 16,
                                        color: "#e61464"
                                    },
                                    type: 'max',
                                    name: '最高点'
                                }]
                            ]
                        },
                        markPoint: {
                            label: {
                                normal: {
                                    // textStyle: {
                                    //     color: '#fff'
                                    // }
                                }
                            },

                        },
                        // data: [],
                    },
                        {

                            name: "报告书",
                            type: "line",
                            // stack: "总量",
                            symbolSize: 10,
                            symbol: 'circle',
                            itemStyle: {
                                color: "#2ce6c4",
                            },
                            color: "#bdddd",
                            label: {
                            normal: {
                                show: true,
                                fontSize: 16,
                                color: "#f7f7b6",
                                textBorderColor: '#333',
                                textBorderWidth: 2
                            }
                        },
                            markLine: {
                                lineStyle: {
                                    width: 2,
                                },
                                label: {
                                    fontSize: 20,
                                    color: "#2ce6c4"
                                },
                                data: [
                                    {type: 'average', name: '平均值'},
                                    [{
                                        symbol: 'none',
                                        x: '90%',
                                        yAxis: 'max'
                                    }, {
                                        symbol: 'circle',
                                        label: {
                                            position: 'start',
                                            formatter: '最大值',
                                            fontSize: 16,
                                            color: "#2ce6c4",
                                        },
                                        type: 'max',
                                        name: '最高点'
                                    }]
                                ]
                            },
                            markPoint: {
                                label: {
                                    normal: {
                                        // textStyle: {
                                        //     color: '#fff'
                                        // }
                                    }
                                },

                            },
                            // data: [],
                        }]
                },
                currentPage: 1,
                page_size: 20,
                total: 0,
            }
        },
        methods: {
            handleSizeChange(val) {
                this.page_size = val

                CreditPorjectRealtimeData(this.eiatypevalue, this.currentPage, val).then(response => {
                    this.total = response.data['count']
                    this.tableData = response.data['result']
                });
            },
            handleCurrentChange(val) {
                this.currentPage = val;

                CreditPorjectRealtimeData(this.eiatypevalue, val, this.page_size).then(response => {
                    this.total = response.data['count']
                    this.tableData = response.data['result']
                });
            },
            eia_type_change(val) {
                this.eiatypevalue = val
                CreditPorjectRealtimeData(val, this.currentPage, this.page_size).then(response => {
                    this.total = response.data['count'];
                    this.tableData = response.data['result']
                });
            }
        },
        mounted() {
            // var waterMarkText = '广州绿网';
            // var canvas = document.createElement('canvas');
            // var ctx = canvas.getContext('2d');
            // canvas.width = canvas.height = 500;
            // ctx.fillStyle = "#1f2b4a";
            // ctx.fillRect(0, 0, 1000, 1000);
            // ctx.textAlign = 'center';
            // ctx.fillStyle = "orange";
            // ctx.textBaseline = 'middle';
            // ctx.font = '30px Microsoft Yahei';
            // ctx.translate(50, 50);
            // ctx.rotate(-Math.PI / 4);
            // ctx.fillText(waterMarkText, 200, 200);
            //
            // this.option.toolbox.feature.saveAsImage.backgroundColor = {
            //     // type: "patten",
            //     image: canvas,
            //     // repeat: 'repeat',
            //
            // };

            this.mychart = echarts.init(document.getElementById('realtime-project-trend'), 'macarons');
            this.mychart.showLoading();
            CreditPorjectRealtimeTrend().then(response => {

                this.option.series[0].data = response.data['result']['报告表']['yxis'];

                this.option.xAxis[0].data = response.data['result']['报告表']['axis'];
                this.option.series[1].data = response.data['result']['报告书']['yxis'];

                // this.option.xAxis[1].data = response.data['result']['报告书']['axis'];
                this.mychart.hideLoading();
                this.mychart.setOption(this.option)

            });
            CreditPorjectRealtimeData().then(response => {
                this.total = response.data['count'];
                this.tableData = response.data['result']
            });
        }
    };
</script>
